export enum Mode {
  Camera = 'camera',
  Review = 'review',
}

export enum FlipMode {
  Front = 'front',
  Back = 'back',
}

export enum PhotoFormat {
  PNG = 'png',
  JPEG = 'jpeg',
  WEBP = 'webp',
}

export type Photo = {
  base64?: string;
  uri?: string;
  width?: number;
  height?: number;
};

export type CameraScreenProps = {
  flip: FlipMode;
  onTakePhoto: (photo: Photo) => void;
  onClose: () => void;
  promptText?: string;
  flippable?: boolean;
  imageOverlay?: string;
  textInstructions?: string;
  isCameraReady?: boolean;
};

export type CameraOptions = {
  maxSize?: number;
  flippable?: boolean;
  promptText?: string;
  landscape?: string;
  format?: PhotoFormat;
  maxWidth?: number;
  maxHeight?: number;
  imageOverlay?: string;
  enablePreview?: boolean;
  textInstructions?: string;
  fixMirroring?: boolean;
};

export type CameraProps = {
  onClose: () => void;
  callback: (picture: string) => void;
  onCameraAccessDenied?: () => void;
  flip: FlipMode;
  options?: CameraOptions;
};

export type PhotoReviewScreenProps = {
  photo: Photo;
  onRetake: () => void;
  onSubmit: (photo: string) => void;
  onClose: () => void;
  flip: string;
  format?: PhotoFormat;
  maxSize?: number;
  landscape?: string;
  maxWidth?: number;
  maxHeight?: number;
  fixMirroring?: boolean;
};
